import React from "react";
import "./PriceCard.css";

const TelegramIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m22 2-7 20-4-9-9-4Z" />
    <path d="m22 2-11 11" />
  </svg>
);

const PhoneIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const WebsiteIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const iconMap = {
  telegram: TelegramIcon,
  phone: PhoneIcon,
  website: WebsiteIcon,
};

const PriceCard = ({ price, title, description, icon, url }) => {
  const IconComponent = iconMap[icon] || TelegramIcon;

  return (
    <div className="horizontal-price-card">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="card-link-overlay"
        aria-label={`View details for ${title}`}
      ></a>

      <div className="price-section">
        <div
          className="price-wrapper"
          style={{
            color:
              price > 10000000
                ? "#10458bff"
                : price === "0"
                ? "#b7b7b7ff"
                : "#1a73e8",
          }}
        >
          {price < 10000000 ? (
            <>
              <span className="price-value">{(price / 10000).toFixed(1)}</span>
              <span className="price-currency">K</span>
            </>
          ) : (
            <>
              <span className="price-value">
                {(price / 10000000).toFixed(2)}
              </span>
              <span className="price-currency">M</span>
            </>
          )}
        </div>
      </div>

      <div className="vertical-divider"></div>

      <div className="names-section" dir="rtl">
        <h3 className="factory-name" title={title}>
          <IconComponent className="factory-icon" />
          {title}
        </h3>
        <p className="channel-name" title={description}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default PriceCard;
